var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      attrs: { active: "", "has-modal-card": "" },
      on: {
        close: function() {
          return _vm.$router.push({ name: "Employees" })
        }
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "modal-card",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.update($event)
            }
          }
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title has-text-primary" }, [
              _vm._v("\n        Edición de empleado\n      ")
            ])
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm.loaded
                ? _c("Employee", { attrs: { loading: _vm.loading } })
                : _vm._e(),
              _c("BLoading", {
                attrs: { "is-full-page": false, active: _vm.loading },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "RouterLink",
                { staticClass: "button", attrs: { to: { name: "Employees" } } },
                [_vm._v("\n        Cerrar\n      ")]
              ),
              _c(
                "button",
                { staticClass: "button is-primary", attrs: { type: "submit" } },
                [_vm._v("\n        Guardar\n      ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }